export function isValidValue(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  const str = String(value).trim();
  return str !== "" && str !== "null" && str !== "undefined";
}

export function isValidCoordinate(value: unknown): value is number {
  if (value === null || value === undefined) return false;
  const str = String(value).trim();
  if (str === "" || str === "null" || str === "undefined") return false;
  const num = Number(value);
  return !isNaN(num) && isFinite(num);
}
